module.exports = __webpack_public_path__ + "img/dice-two.0d67c40d.svg";